import React from 'react'
import style from "./style.scss";

const Label = ({ value, classN = "" }) => {
    return (
        <label className={classN}>{value}</label>
    )
}

export default Label